<template>
  <div class="market-price-detail-modal-table">
    <template>
      <table class="table amt-table" style="width:100%">
        <thead>
        <tr>
          <th class="col-1">구매일</th>
          <th class="col-1">결제일</th>
          <th class="col-1">구분</th>
          <th class="col-4">내용</th>
          <th class="col-2">플랜</th>
          <th class="col-2">서비스 이용기간</th>
          <th class="col-1">금액</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, item_idx) in next_date_info.list" :key="`item-${item_idx}`">
          <td>{{ datesFormat(item.created_time, 'date_3') }}</td>
          <td>{{ datesFormat(item.next_date, 'date_3') }}</td>
          <td>{{ appType(item) }}</td>
          <td><div style="white-space: pre-line">{{ name(item) }}</div></td>
          <td><span v-if="item.membership_name">{{ item.membership_name }}</span> {{ item.date_unit }}개월</td>
          <td>{{ period(item) }}</td>
          <td>{{ item.price | currency }}</td>
        </tr>
        </tbody>
      </table>

      <div class="flex-end" style="padding: 0 17px;">
        <div class="flex-between" style=";width:170px">
          <div class="main">소계</div>
          <div>{{ next_date_info.total_pay_price * 10 / 11 | currency }}</div>
        </div>
      </div>
      <div class="flex-end" style="padding: 0 17px;margin-top:8px">
        <div class="flex-between" style="width:170px">
          <div class="main">부가세(10%)</div>
          <div>{{ next_date_info.total_pay_price / 11 | currency }}</div>
        </div>
      </div>

      <div class="flex-between" style="padding: 0 17px;margin-top:12px">
        <div>
          <span style="margin-right:8px">결제 수단</span>
          <span>{{ service.credit_card !== '' ? service.credit_card : '미등록'  }}</span>
        </div>

        <div class="flex-between" style="width: 170px;padding-bottom: 24px">
          <div style="font-weight:bold;color:#363636;">총합계</div>
          <div>{{ next_date_info.total_pay_price | currency }}</div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
  export default {
    props: {
      service: {
        type: Object
      },
      next_date_info: {
        type: Object
      }
    },
    name: "NextDatePriceDetailModal",
    created() {
    },
    data() {
      return {
      }
    },
    methods: {
      name(item) {
        let result = '';
        item.products.forEach(i => {
          if(result !== '') {
            result += '\n';
          }
          result += i.name
        });
        return result;
      },
      appType(item) {
        if(item.main) {
          return '솔루션';
        } else {
          return item.products[0].category;
        }
      },
      period(item) {
        return `${this.datesFormat(item.start_date, 'date_3')} ~ ${this.datesFormat(item.end_date, 'date_3')}`;
      }
    }
  }
</script>
<style lang="stylus" scoped>
  .market-price-detail-modal-table tbody tr:last-child
    border-bottom 1px solid #000000
</style>
